/**
 * seo的路由一般要求name和id拼一起 [name]-p-[id].html, 需要配置一个分隔符
 */

const separator = {
  "/product": "-p-",
  "/list": "-l-",
};

module.exports = separator